module.exports = __webpack_public_path__ + "a9c6e12285410042a894010e0e2880ff.pdf";